<div class="layout-ParentDiv innerDiv">
  <div class="layout-dashboard addPage">
    <div class="p-grid">
      <div class="p-col-12 mainFormPadding">
        <div class="card ">
          <p-toast key="toastmsg"></p-toast>
          <form [formGroup]="bannerForm">
            <div class="p-fluid p-formgrid p-grid m-0">
              <div class="p-field p-col-12 div-border p-p-0">
                <h3 class="head-page-title">
                  {{pagetitle}}
                </h3>
              </div>
            </div>

            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                <div class="p-fluid p-formgrid p-grid baner-image-update">
                  <div class="p-field p-col-6">
                    <label>Web Banner Title<span class="mandatory-feilds">*</span></label>
                    <input id="banner_title" placeholder="Enter Banner Title" formControlName="banner_title" type="text"
                      pInputText [ngClass]="{ 'is-invalid': submitted && f.banner_title.errors }">
                    <div *ngIf="submitted && f.banner_title.errors" class="invalid-feedback">
                      <div *ngIf="f.banner_title.errors.required">Banner Title is required</div>
                      <div *ngIf="!f.banner_title.errors">Numbers, Space and Special characters not allowed.</div>
                    </div>
                  </div>
                  <!-- <div class="p-field p-col-6">
              <label>Banner Url<span class="mandatory-feilds">*</span></label>
              <input id="banner_url" placeholder="Enter banner URL(https://fascinatingdiamonds.com)"
                formControlName="banner_url" type="text" pInputText
                [ngClass]="{ 'is-invalid': submitted && f.banner_url.errors }">
              <div *ngIf="submitted && f.banner_url.errors" class="invalid-feedback">
                <div *ngIf="f.banner_url.errors.required">Banner URL is required</div>
                <div *ngIf="f.banner_url.errors">Wrong URL</div>
              </div>
            </div> -->
                  <div class="p-field p-col-6">
                    <label>Web Banner Slug<span class="mandatory-feilds">*</span></label>
                    <input placeholder="Enter Banner slug" formControlName="slug" type="text" pInputText
                      [ngClass]="{ 'is-invalid': submitted && f.slug.errors }">
                    <div *ngIf="submitted && f.slug.errors" class="invalid-feedback">
                      <div *ngIf="f.slug.errors.required">Banner Slug is required</div>
                      <div *ngIf="!f.slug.errors">Only Alphabets and _ Allowed</div>
                    </div>
                  </div>
                  <!-- <div class="p-field p-col-6">
              <label>Banner Content</label>
              <input id="banner_content" placeholder="Enter Banner Content" formControlName="banner_content" type="text"
                pInputText>
            </div> -->
                  <input formControlName="disable" type="hidden" value="false">
                  <div class="p-field p-col-12 uploadBtn">
                    <div class="subTitleLable">
                      <h4>Web Image Upload</h4>
                    </div>
                    <!-- <p-fileUpload multiple="multiple" chooseLabel="Upload Banner" uploadLabel="Show data"
                      cancelLabel="Cancel" accept="image/*" maxFileSize="10000000" auto="auto" customUpload="true"
                      (uploadHandler)="picUploader($event)" (onRemove)="removeBannerImage($event)">
                      <ng-template pTemplate="content">
                        <div formArrayName="banner_image_links" class="d-flex">
                          <div *ngFor="let bannerImageLink of bannerImageLinksArray().controls; let i=index;"
                            [formGroupName]="i">
                            <div class="p-field p-col-12 mt-3">
                              <label style="width: 100%;">Order</label>
                              <input type="number" name="order" formControlName="order" id="order"
                                placeholder="Enter order" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && bannerImageLinksArray().controls[i]['controls']['order'].errors }">
                              <div *ngIf="submitted && bannerImageLinksArray().controls[i]['controls']['order'].errors"
                                class="invalid-feedback">
                                <div *ngIf="bannerImageLinksArray().controls[i]['controls']['order'].errors.required">
                                  Banner Order is required</div>
                              </div>
                            </div>
                            <div class="p-field p-col-12 mt-3">
                              <label style="width: 100%;">Image Link</label>
                              <input type="text" name="bannerimagelink" formControlName="bannerImageLink"
                                id="bannerimagelink" placeholder="Enter Image Link" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors }">
                              <div
                                *ngIf="submitted && bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors"
                                class="invalid-feedback">
                                <div
                                  *ngIf="bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors.pattern">
                                  Please start the link with https:// or http://</div>
                              </div>
                            </div>
                            <div class="p-field p-col-12 addFormDropDown">
                              <label style="width: 100%;">Banner Image Link Type</label>
                              <p-dropdown inputId="status" [options]="bannerImageTypes"
                                formControlName="bannerImageLinkType" placeholder="Select" [showClear]="true"
                                optionLabel="label"></p-dropdown>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-fileUpload> -->

                    <p-fileUpload #fileUpload1 mode="advanced" name="myfiles[]" multiple="multiple"
                      chooseLabel="Upload Banner" uploadLabel="Show data" cancelLabel="Cancel" accept="image/*"
                      maxFileSize="1000000" auto="auto" [customUpload]="true"
                      (onSelect)="onMultipleFileSelect($event,'webBannerImage')" (onRemove)="removeBannerImage($event)">
                      <ng-template pTemplate="content">
                        <div formArrayName="banner_image_links" class="d-flex flex-wrap">
                          <div *ngFor="let bannerImageLink of bannerImageLinksArray().controls; let i=index;"
                            [formGroupName]="i" class="uploaded-banner-item-group col-12 col-md-4 mb-3">
                            
                            <!-- Uploaded Image Preview Row -->
                            <div class="uploaded-banner-preview-card" *ngIf="bannerImage[i]?.file">
                              <div class="preview-thumb-box">
                                <img [src]="bannerImage[i]?.file" alt="Banner Preview" class="preview-thumb-img" />
                              </div>
                              <div class="preview-file-info">
                                <span class="preview-file-name" [title]="bannerImage[i]?.name || uploadedFiles[i]?.name || sampleBannerImageLinkArray[i]">{{bannerImage[i]?.name || uploadedFiles[i]?.name || sampleBannerImageLinkArray[i]}}</span>
                                <span class="preview-file-size">{{formatFileSize(bannerImage[i]?.size || uploadedFiles[i]?.size)}}</span>
                              </div>
                              <button type="button" class="preview-remove-circle-btn" (click)="removeUploadedBannerImage(i)" title="Remove Image">
                                <i class="pi pi-times"></i>
                              </button>
                            </div>

                            <div class="p-field p-col-12 mt-2">
                              <label style="width: 100%;">Order</label>
                              <input type="number" name="order" formControlName="order" id="order"
                                placeholder="Enter order" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && bannerImageLinksArray().controls[i]['controls']['order'].errors }">
                              <div *ngIf="submitted && bannerImageLinksArray().controls[i]['controls']['order'].errors"
                                class="invalid-feedback">
                                <div *ngIf="bannerImageLinksArray().controls[i]['controls']['order'].errors.required">
                                  Banner Order is required</div>
                              </div>
                            </div>
                            <div class="p-field p-col-12 mt-2">
                              <label style="width: 100%;">Image Link</label>
                              <input type="text" name="bannerimagelink" formControlName="bannerImageLink"
                                id="bannerimagelink" placeholder="Enter Image Link" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors }">
                              <div
                                *ngIf="submitted && bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors"
                                class="invalid-feedback">
                                <div
                                  *ngIf="bannerImageLinksArray().controls[i]['controls']['bannerImageLink'].errors.pattern">
                                  Please start the link with https:// or http://</div>
                              </div>
                            </div>
                            <div class="p-field p-col-12 addFormDropDown">
                              <label style="width: 100%;">Banner Image Link Type</label>
                              <p-dropdown inputId="status" [options]="bannerImageTypes"
                                formControlName="bannerImageLinkType" placeholder="Select" [showClear]="true"
                                optionLabel="label"></p-dropdown>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-fileUpload>
                    <div class="instruction mt-3 mb-3">
                      <p>Instructions: </p>
                      <ul>
                        <li>The width and height of the web banner should be height: 512px and width: 1024px ,
                          with a maximum size of
                          1 Mb.</li>
                        <li>
                          Top Safe Area: 100 px height from the top edge. This area may
                          contain a continuation of the background image, color, gradient, or
                          design elements to ensure a seamless visual appearance.
                        </li>
                        <li> Design Area: Place all key visuals, logos, text, CTAs, and other
                          important content below the 100 px safe area.<br>
                          Safe Margin: Do not place any critical content within the top 100
                          px area, as it may be partially covered by the web navigation interface.<br></li>
                        <li> File Size: Maximum 1 MB.</li>
                      </ul>
                    </div>
                    <div class="lineborderHR">
                      <hr>
                    </div>
                  </div>
                  <div class="p-field p-col-6">
                    <label>Mobile Banner Title<span class="mandatory-feilds">*</span></label>
                    <input id="mobile_banner_title" placeholder="Enter Mobile Banner Title"
                      formControlName="mobile_banner_title" type="text" pInputText
                      [ngClass]="{ 'is-invalid': submitted && f.mobile_banner_title.errors }">
                    <div *ngIf="submitted && f.mobile_banner_title.errors" class="invalid-feedback">
                      <div *ngIf="f.mobile_banner_title.errors.required">Mobile Banner Title is required</div>
                      <div *ngIf="!f.mobile_banner_title.errors">Numbers, Space and Special characters not allowed.
                      </div>
                    </div>
                  </div>
                  <div class="p-field p-col-6">
                    <label>Mobile Banner Slug<span class="mandatory-feilds">*</span></label>
                    <input placeholder="Enter Mobile Banner slug" formControlName="mobile_slug" type="text" pInputText
                      [ngClass]="{ 'is-invalid': submitted && f.mobile_slug.errors }">
                    <div *ngIf="submitted && f.mobile_slug.errors" class="invalid-feedback">
                      <div *ngIf="f.mobile_slug.errors.required">Mobile Banner Slug is required</div>
                      <div *ngIf="!f.mobile_slug.errors">Only Alphabets and _ Allowed</div>
                    </div>
                  </div>
                  <input formControlName="disable" type="hidden" value="false">
                  <div class="p-field p-col-12 uploadBtn">
                    <div class="subTitleLable">
                      <h4>Mobile Image Upload</h4>
                    </div>
                    <!-- <p-fileUpload multiple="multiple" chooseLabel="Upload Banner" uploadLabel="Show data"
                      cancelLabel="Cancel" accept="image/*" maxFileSize="10000000" auto="auto" customUpload="true"
                      (uploadHandler)="mobilePicUploader($event)" (onRemove)="removeMobileBannerImage($event)">
                      <ng-template pTemplate="content">
                        <div formArrayName="mobile_banner_image_links" class="d-flex">
                          <div
                            *ngFor="let mobileBannerImageLink of mobileBannerImageLinksArray().controls; let i=index;"
                            [formGroupName]="i">
                            <div class="p-field p-col-12 mt-3">
                              <label style="width: 100%;">Order</label>
                              <input type="number" name="order" formControlName="order" id="order"
                                placeholder="Enter order" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && mobileBannerImageLinksArray().controls[i]['controls']['order'].errors }">
                              <div
                                *ngIf="submitted && mobileBannerImageLinksArray().controls[i]['controls']['order'].errors"
                                class="invalid-feedback">
                                <div
                                  *ngIf="mobileBannerImageLinksArray().controls[i]['controls']['order'].errors.required">
                                  Banner Order is required</div>
                              </div>
                            </div>

                            <div class="p-field p-col-12 mt-3">
                              <label style="width: 100%;">Image Link</label>
                              <input type="text" name="mobilebannerimagelink" formControlName="mobileBannerImageLink"
                                id="mobilebannerimagelink" placeholder="Enter Image link"
                                [ngClass]="{ 'is-invalid': submitted && mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors }">
                              <div *ngIf="submitted && mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors" class="invalid-feedback">
                                <div *ngIf="mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors.pattern">
                                  Please start the link with https:// or http://</div>
                              </div>
                            </div>
                            <p-dropdown inputId="status" [options]="bannerImageTypes"
                              formControlName="mobileBannerImageLinkType" [showClear]="true" placeholder="Select"
                              optionLabel="label"></p-dropdown>
                          </div>
                        </div>
                      </ng-template>
                    </p-fileUpload> -->

                    <p-fileUpload #fileUpload2 mode="advanced" name="myfiles[]" multiple="multiple"
                      chooseLabel="Upload Banner" uploadLabel="Show data" cancelLabel="Cancel" accept="image/*"
                      maxFileSize="1000000" auto="auto" [customUpload]="true"
                      (onSelect)="onMultipleFileSelect($event,'mobileBannerImage')"
                      (onRemove)="removeMobileBannerImage($event)">
                      <ng-template pTemplate="content">
                        <div formArrayName="mobile_banner_image_links" class="d-flex flex-wrap">
                          <div
                            *ngFor="let mobileBannerImageLink of mobileBannerImageLinksArray().controls; let i=index;"
                            [formGroupName]="i" class="uploaded-banner-item-group col-12 col-md-4 mb-3">
                            
                            <!-- Uploaded Image Preview Row -->
                            <div class="uploaded-banner-preview-card" *ngIf="mobileBannerImage[i]?.file">
                              <div class="preview-thumb-box">
                                <img [src]="mobileBannerImage[i]?.file" alt="Mobile Banner Preview" class="preview-thumb-img" />
                              </div>
                              <div class="preview-file-info">
                                <span class="preview-file-name" [title]="mobileBannerImage[i]?.name || mobileUploadedFiles[i]?.name || sampleMobileBannerImageLinkArray[i]">{{mobileBannerImage[i]?.name || mobileUploadedFiles[i]?.name || sampleMobileBannerImageLinkArray[i]}}</span>
                                <span class="preview-file-size">{{formatFileSize(mobileBannerImage[i]?.size || mobileUploadedFiles[i]?.size)}}</span>
                              </div>
                              <button type="button" class="preview-remove-circle-btn" (click)="removeUploadedMobileBannerImage(i)" title="Remove Image">
                                <i class="pi pi-times"></i>
                              </button>
                            </div>

                            <div class="p-field p-col-12 mt-2">
                              <label style="width: 100%;">Order</label>
                              <input type="number" name="order" formControlName="order" id="order"
                                placeholder="Enter order" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && mobileBannerImageLinksArray().controls[i]['controls']['order'].errors }">
                              <div
                                *ngIf="submitted && mobileBannerImageLinksArray().controls[i]['controls']['order'].errors"
                                class="invalid-feedback">
                                <div
                                  *ngIf="mobileBannerImageLinksArray().controls[i]['controls']['order'].errors.required">
                                  Banner Order is required</div>
                              </div>
                            </div>

                            <div class="p-field p-col-12 mt-2">
                              <label style="width: 100%;">Image Link</label>
                              <input type="text" name="mobilebannerimagelink" formControlName="mobileBannerImageLink"
                                id="mobilebannerimagelink" placeholder="Enter Image link" style="width: 100%;"
                                [ngClass]="{ 'is-invalid': submitted && mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors }">
                              <div
                                *ngIf="submitted && mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors"
                                class="invalid-feedback">
                                <div
                                  *ngIf="mobileBannerImageLinksArray().controls[i]['controls']['mobileBannerImageLink'].errors.pattern">
                                  Please start the link with https:// or http://</div>
                              </div>
                            </div>
                            <div class="p-field p-col-12 addFormDropDown">
                              <label style="width: 100%;">Banner Image Link Type</label>
                              <p-dropdown inputId="status" [options]="bannerImageTypes"
                                formControlName="mobileBannerImageLinkType" [showClear]="true" placeholder="Select"
                                optionLabel="label"></p-dropdown>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-fileUpload>
                    <div class="instruction mt-3 mb-3">
                      <p>Instructions: </p>
                      <ul>
                        <li> Mobile Banner Size: 1500 px (W) × 1050 px (H)
                        </li>
                        <li>
                          Top Safe Area: 345 px height from the top edge. This area may
                          contain a continuation of the background image, color, gradient, or
                          design elements to ensure a seamless visual appearance.
                        </li>
                        <li> Design Area: Place all key visuals, logos, text, CTAs, and other
                          important content below the 345 px safe area.<br>
                          Safe Margin: Do not place any critical content within the top 345
                          px
                          area, as it may be partially covered by the mobile app
                          interface.<br></li>
                        <li> File Size: Maximum 1 MB.</li>
                        <li>
                          <a (click)="showInstructionModal = true" href="javascript:void(0);">View Sample File</a>
                        </li>

                      </ul>
                    </div>
                    <div class="lineborderHR">
                      <hr>
                    </div>
                  </div>


                  <div class="p-field p-col-1 ">
                    <div class="statusdiv ">
                      <label for="status">Status</label>
                      <div class="swichTable">
                        <p-inputSwitch class="checkbox-mt-10" formControlName="status"
                          [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                      </div>
                    </div>
                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                      <div *ngIf="f.status.errors.required">Please Select Status</div>
                    </div>
                  </div>
                </div>
                <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer">
                  <div class="p-formgrid p-grid">
                    <p-toast></p-toast>
                    <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                      class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                    <p-confirmDialog header="Confirmation" key="confirm1" icon="pi pi-exclamation-triangle"
                      message="Are you sure you want to proceed?" [style]="{width: '425px'}"
                      acceptButtonStyleClass="p-button-text" rejectButtonStyleClass="p-button-text"></p-confirmDialog>
                    <!-- <button pButton pRipple label="Reset" icon="pi pi-times" type="reset" (click)="onReset()"
              style="width: auto" class="p-mr-3"></button> -->

                    <button pButton pRipple type="button" icon="pi pi-times" label="Cancel" class="cancel-btn"
                      (click)="backLink()" style="width: auto"></button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>


  </div>
</div>
<p-dialog [(visible)]="cropDialog" [closable]="true" (onHide)="onDialogHide()" [modal]="true"
  [appendTo]="'body'" [style]="{width: '760px'}" [breakpoints]="{'768px': 'calc(100vw - 24px)'}"
  styleClass="custom-crop-dialog">
  <ng-template pTemplate="header">
    <div class="crop-header-wrapper">
      <div class="crop-header-icon-box">
        <i class="pi pi-image header-icon"></i>
      </div>
      <div class="crop-header-text">
        <h5 class="crop-dialog-title">{{cropDialogTitle}}</h5>
        <p class="crop-dialog-subtitle">{{cropDialogSubtitle}}</p>
      </div>
    </div>
  </ng-template>

  <div class="crop-dialog-content-wrapper">
    <!-- Web Banner Safe Area Alert Banner -->
    <div class="crop-safe-guide-banner mb-3" *ngIf="fileUploader === 'webBannerImage'">
      <div class="banner-icon-box">
        <i class="pi pi-shield"></i>
      </div>
      <div class="banner-text">
        <div class="banner-heading">Web Safe Area Guideline (1024 × 512 px)</div>
        <div class="banner-desc">
          Top <strong>100 px</strong> is reserved for header navigation / overlay space. Place all key text, logos & CTAs in the lower <strong>412 px</strong> safe design area.
        </div>
      </div>
    </div>

    <!-- Mobile Banner Safe Area Alert Banner -->
    <div class="crop-safe-guide-banner mb-3" *ngIf="fileUploader === 'mobileBannerImage'">
      <div class="banner-icon-box">
        <i class="pi pi-shield"></i>
      </div>
      <div class="banner-text">
        <div class="banner-heading">Mobile Safe Area Guideline (1500 × 1050 px)</div>
        <div class="banner-desc">
          Top <strong>345 px</strong> is reserved for app header / status bar. Place all key text, logos & CTAs in the lower <strong>705 px</strong> safe design area.
          <a href="javascript:void(0);" (click)="showInstructionModal = true" class="sample-spec-link">
            <i class="pi pi-external-link mr-1"></i>View Guide
          </a>
        </div>
      </div>
    </div>

    <div class="crop-toolbar-bar mb-3">
      <div class="toolbar-hint">
        <i class="pi pi-sliders-h mr-2 hint-icon"></i>
        <span>Zoom & Scale</span>
      </div>
      <div class="zoom-actions">
        <button type="button" pButton icon="pi pi-shield"
          [label]="showSafeGuide ? 'Hide Safe Area' : 'Show Safe Area'"
          class="crop-btn guide-btn" [class.active-guide]="showSafeGuide"
          (click)="toggleSafeGuide()" *ngIf="fileUploader === 'mobileBannerImage' || fileUploader === 'webBannerImage'"></button>
        <button type="button" pButton icon="pi pi-search-plus" label="Zoom In" class="crop-btn zoom-btn"
          (click)="zoomIn()" [disabled]="scale >= 3"></button>
        <button type="button" pButton icon="pi pi-search-minus" label="Zoom Out" class="crop-btn zoom-btn"
          (click)="zoomOut()" [disabled]="scale <= 0.1"></button>
        <button type="button" pButton icon="pi pi-refresh" label="Reset" class="crop-btn reset-btn"
          (click)="resetZoom()"></button>
      </div>
    </div>

    <div class="cropper-frame mb-3" [class.has-safe-guide]="showSafeGuide">
      <image-cropper *ngIf="fileUploader === 'webBannerImage'" [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true" [containWithinAspectRatio]="true" [aspectRatio]="1024 / 512" [resizeToWidth]="1024"
        [resizeToHeight]="512" [onlyScaleDown]="false" [imageQuality]="92" [backgroundColor]="'#ffffff'"
        [transform]="transform" format="jpeg" (imageCropped)="imageCropped($event)"
        (loadImageFailed)="onCropImageLoadFailed()">
      </image-cropper>

      <image-cropper *ngIf="fileUploader === 'mobileBannerImage'" [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="true" [containWithinAspectRatio]="true" [aspectRatio]="1500 / 1050"
        [resizeToWidth]="1500" [resizeToHeight]="1050" [onlyScaleDown]="false" [imageQuality]="92"
        [backgroundColor]="'#ffffff'" [transform]="transform" format="jpeg" (imageCropped)="imageCropped($event)"
        (loadImageFailed)="onCropImageLoadFailed()">
      </image-cropper>

      <!-- Safe Area Overlay for Web Banner -->
      <div class="safe-area-overlay-guide web-guide" *ngIf="fileUploader === 'webBannerImage' && showSafeGuide">
        <div class="top-blank-zone web-top-zone">
          <span class="zone-badge header-zone-badge">
            <i class="pi pi-ban mr-1"></i> Top 100px Header Space (Keep Clear of Text/Logos)
          </span>
        </div>
        <div class="safe-content-zone web-safe-zone">
          <span class="zone-badge safe-zone-badge">
            <i class="pi pi-check-circle mr-1"></i> Safe Content Area (412px)
          </span>
        </div>
      </div>

      <!-- Safe Area Overlay for Mobile Banner -->
      <div class="safe-area-overlay-guide" *ngIf="fileUploader === 'mobileBannerImage' && showSafeGuide">
        <div class="top-blank-zone">
          <span class="zone-badge header-zone-badge">
            <i class="pi pi-ban mr-1"></i> Top 345px Header Space (Keep Clear of Text/Logos)
          </span>
        </div>
        <div class="safe-content-zone">
          <span class="zone-badge safe-zone-badge">
            <i class="pi pi-check-circle mr-1"></i> Safe Content Area (705px)
          </span>
        </div>
      </div>
    </div>

    <div class="crop-error-msg mb-3" *ngIf="croppedImageError">
      <i class="pi pi-exclamation-triangle mr-2"></i>
      <span>{{croppedImageError}}</span>
    </div>

    <div class="cropped-preview-box" *ngIf="croppedImage">
      <div class="preview-header">
        <div class="preview-title">
          <i class="pi pi-eye mr-2 text-primary"></i>
          <span>Live Cropped Preview</span>
        </div>
        <span class="preview-ratio-badge">{{cropPreviewLabel}}</span>
      </div>
      <div class="preview-img-container" [class.has-safe-preview]="showSafeGuide">
        <div class="preview-img-wrapper">
          <img [src]="croppedImage" alt="Cropped Banner Preview" class="preview-img" />
          
          <!-- Web Banner Preview Overlay -->
          <div class="preview-safe-overlay web-preview-overlay" *ngIf="fileUploader === 'webBannerImage' && showSafeGuide">
            <div class="preview-top-zone web-preview-top">
              <span class="p-zone-tag top-tag">100px Clear Area</span>
            </div>
            <div class="preview-bottom-zone web-preview-bottom">
              <span class="p-zone-tag safe-tag">412px Safe Area</span>
            </div>
          </div>

          <!-- Mobile Banner Preview Overlay -->
          <div class="preview-safe-overlay" *ngIf="fileUploader === 'mobileBannerImage' && showSafeGuide">
            <div class="preview-top-zone">
              <span class="p-zone-tag top-tag">345px Clear Area</span>
            </div>
            <div class="preview-bottom-zone">
              <span class="p-zone-tag safe-tag">705px Safe Area</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-actions">
      <button type="button" pButton label="Cancel" icon="pi pi-times" class="cancel-action-btn"
        (click)="onCropCancel()"></button>
      <button type="button" pButton label="Use Image" icon="pi pi-check" class="use-image-btn" (click)="applyCrop()"
        [disabled]="isApplyingCrop || !!croppedImageError || !croppedImage"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showInstructionModal" [modal]="true" [appendTo]="'body'" [style]="{width: 'auto'}"
  [header]="'Instruction Sample Image'" [resizable]="true" draggable="false">
  <div class="p-text-center text-center">
    <img src="assets/images/instruction.png" alt="Instruction Sample"
      style="width: 100%; height: auto; max-height: 75vh; object-fit: contain;" />
  </div>
</p-dialog>